import React from 'react';
const _addComma = (price) => {
  let returnString = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return returnString;
};
const WidgetStock = (props) => {
  //console.log(props);
  const _goHome = () => {
    props.actionProvider._home(-1);
  };
  const stockInfo = props.payload.list;
  return (
    <>
      <div className="stock-info-wrapper">
        <div className="stock-header">
          <h1>애니플러스 {stockInfo.cd} KOSDAQ</h1>
        </div>
        <div
          className={
            stockInfo.nv === stockInfo.ov
              ? 'stock-price'
              : stockInfo.nv > stockInfo.ov
              ? 'stock-price-red'
              : 'stock-price-blue'
          }
        >
          {_addComma(stockInfo.nv)}{' '}
          <em
            className={
              stockInfo.nv === stockInfo.ov
                ? 'stock-rate-black'
                : stockInfo.nv > stockInfo.ov
                ? 'stock-rate-red'
                : 'stock-rate-blue'
            }
          >
            {_addComma(stockInfo.cv)}(
            {stockInfo.nv === stockInfo.ov
              ? ''
              : stockInfo.nv > stockInfo.ov
              ? '+'
              : '-'}
            {stockInfo.cr}%)
          </em>
        </div>
        <div className="stock-details">
          <div className="stock-detail">
            <span className="detail-label-red">상한가</span>
            <span className="detail-value-red">{_addComma(stockInfo.ul)}</span>
          </div>
          <div className="stock-detail">
            <span className="detail-label-blue">하한가</span>
            <span className="detail-value-blue">{_addComma(stockInfo.ll)}</span>
          </div>
          {/* <div className="stock-detail">
          <span className="detail-label">시가</span>
          <span className="detail-value">{stockInfo.ov}</span>
        </div> */}
          <div className="stock-detail">
            <span className="detail-label-red">고가</span>
            <span className="detail-value-red">{_addComma(stockInfo.hv)}</span>
          </div>
          <div className="stock-detail">
            <span className={'detail-label-blue'}>저가</span>
            <span className={'detail-value-blue'}>
              {_addComma(stockInfo.lv)}
            </span>
          </div>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default WidgetStock;
